import { Space } from 'antd';
import { AvatarProps } from 'antd/es/avatar';
import React, { CSSProperties, useContext } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { User } from '@/models/user';
import { getUserAvatar } from '@/utils/uiHelper';
import UserName from './Name';

export type Props = {
  user: User;
  avatarProps?: AvatarProps;
  className?: string;
  style?: CSSProperties;
};

const UserAvatar: React.FC<Props> = ({ user, avatarProps = {}, className = '', style }: Props) => {
  const [{}, , helpers] = useContext(BaseInfoContext);
  return (
    <Space className={className} style={style}>
      <div
        onDoubleClick={e => {
          e.stopPropagation();
          helpers.showUserModal({
            userId: user.id,
          });
        }}>
        {getUserAvatar(user, {
          ...avatarProps,
          draggable: false,
          // size: avatarProps?.size ?? 'default',
        })}
      </div>
      <UserName user={user} />
    </Space>
  );
};

export default UserAvatar;
